export default {
  namespaced: true,
  state: {
    queryString: {
      q: '',
      sort: '',
      limit: 12,
      skip: 0,
      brands: '',
      category: '',
      prices: '',
      origins: '',
      rating: '',
      products: '',
      available_for: '',
    },
    filterType: 'none',
    paramsType: 'none',
    initial: true,
  },
  mutations: {
    SET_QUERY_STRING(state, { name, value }) {
      state.queryString[name] = value;
    },
    DESTROY_QUERY_STRING(state, data) {
      if (data && Object.keys(data).length) {
        state.queryString = data;
      } else {
        state.queryString = {
          q: '',
          sort: '',
          limit: 16,
          skip: 0,
          brands: '',
          category: '',
          prices: '',
          origins: '',
          rating: '',
          products: '',
        };
      }
    },
    SET_FILTER_TYPE(state, data) {
      // for checking filter need to use api count or not
      // first load will not upated
      state.filterType = data;
    },
    SET_PARAMS_TYPE(state, data) {
      // for type of params
      // always updated
      state.paramsType = data;
    },
    SET_INITIAL(state, data) {
      state.initial = data;
    },
  },
  actions: {
    serialize({ commit, state }, query) {
      if (typeof query === 'object') {
        for (const prop in query) {
          if (query.hasOwnProperty(prop)) {
            if (prop === 'prices') {
              const prices = query[prop].split(',');
              if (Number(prices[0]) !== 0 && Number(prices[1]) !== 1000000 && Number(prices[0]) !== Number(prices[1])) {
                commit('SET_QUERY_STRING', { name: prop, value: query[prop] });
              }
            } else if (prop === 'page') {
              commit('SET_QUERY_STRING', {
                name: 'skip',
                value: state.queryString.limit * (query[prop] - 1),
              });
            } else {
              commit('SET_QUERY_STRING', { name: prop, value: query[prop] });
            }
          }
        }

        if (!query.page && state.queryString.skip) {
          commit('SET_QUERY_STRING', { name: 'skip', value: 0 });
        }
      }
    },
    setFilterType({ commit, state }, { from, to }) {
      let filter = 'none';
      let params = 'none';
      if (Object.keys(to).length) {
        let result = {};
        if (Object.keys(from).length) {
          const keys = Object.keys(from);
          for (const key in to) {
            if (!keys.includes(key)) {
              result[key] = to[key];
            } else {
              if (to[key] !== from[key]) {
                result[key] = to[key];
              }
            }
          }
        } else {
          result = to;
        }
        if (result.sort || (result.skip && result.skip > 0) || result.limit || (result.page && result.page > 0)) {
          if (!state.initial) {
            filter = 'sort';
          }
          params = 'sort';
        } else {
          if (!state.initial) {
            filter = 'filtered';
          }
          params = 'filtered';
        }
      }
      commit('SET_PARAMS_TYPE', params);
      commit('SET_FILTER_TYPE', filter);
      commit('SET_INITIAL', false);
    },
  },
  getters: {
    filterType: (state) => state.filterType,
  },
};
